// Lightweight planar geometry — city-scale only, no geo library needed.

/** Bounding-box centre of any GeoJSON geometry as {lat, lng}. */
export function geometryCenter(geometry) {
  let minLat = Infinity
  let maxLat = -Infinity
  let minLng = Infinity
  let maxLng = -Infinity
  const walk = (c) => {
    if (typeof c[0] === 'number') {
      const [lng, lat] = c
      if (lat < minLat) minLat = lat
      if (lat > maxLat) maxLat = lat
      if (lng < minLng) minLng = lng
      if (lng > maxLng) maxLng = lng
    } else {
      for (const x of c) walk(x)
    }
  }
  if (!geometry || !geometry.coordinates) return null
  walk(geometry.coordinates)
  if (!Number.isFinite(minLat)) return null
  return { lat: (minLat + maxLat) / 2, lng: (minLng + maxLng) / 2 }
}

// Metres per degree at Prague's latitude band (equirectangular; <1% error here).
const M_PER_DEG_LAT = 110_574
const mPerDegLng = (lat) => 111_320 * Math.cos((lat * Math.PI) / 180)

/**
 * A circle of `radiusM` metres as a closed GeoJSON polygon — the GPS accuracy
 * ring. Drawn as geometry (not a pixel circle) so it scales correctly with zoom.
 */
export function circlePolygon(lng, lat, radiusM, steps = 48) {
  const dLat = radiusM / M_PER_DEG_LAT
  const dLng = radiusM / mPerDegLng(lat)
  const ring = []
  for (let i = 0; i < steps; i++) {
    const a = (i / steps) * 2 * Math.PI
    ring.push([lng + dLng * Math.cos(a), lat + dLat * Math.sin(a)])
  }
  ring.push(ring[0])
  return { type: 'Feature', properties: {}, geometry: { type: 'Polygon', coordinates: [ring] } }
}

/** Equirectangular distance in metres between two {lat,lng}. */
export function distanceMeters(a, b) {
  const dLat = (b.lat - a.lat) * M_PER_DEG_LAT
  const dLng = (b.lng - a.lng) * mPerDegLng((a.lat + b.lat) / 2)
  return Math.sqrt(dLat * dLat + dLng * dLng)
}
